// services/prescriptionService.js

import http from "@/services/http";

/**
 * Dados completos para montar o receituário em PDF: identificação do paciente
 * e do prescritor, clínica emitente, itens com posologia completa e CIDs.
 *
 * Endpoint separado da listagem de propósito — a listagem é chamada a cada
 * abertura da aba e não deve arrastar endereço/telefone de duas pessoas por
 * linha. Aqui o custo só é pago quando alguém baixa o PDF.
 *
 * @param {number|string} prescriptionId
 * @param {Object} [options]
 * @param {number|null} [options.clinicId] clínica em nome da qual a receita é
 *        emitida (a mesma dona do timbre escolhido)
 */
export async function getPrescriptionDocument(prescriptionId, { clinicId } = {}) {
  const { data } = await http.get(`/api/prescription/${prescriptionId}/document`, {
    params: clinicId ? { clinic_id: clinicId } : undefined,
  });
  return data?.data || null;
}
